import React, { useState } from "react";
import "./StoryEngagementOverTime.scss";
import StoryViewsExits from "../StoryViewsExits/StoryViewsExits";
import StoryReplies from "../StoryReplies/StoryReplies";
import StoriesTaps from "../StoriesTaps/StoriesTaps";
import StoriesReach from "../StoriesReach/StoriesReach";
import ChartName from "../../../../../Dashboard/Charts/ChartName";
import { Icon } from "semantic-ui-react";
import { ReactComponent as MoreOptions } from "../../../../../../../assets/svg/menu.svg";
import { ReactComponent as CloneIcon } from "../../../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../../../../assets/svg/settings.svg";
import { ReactComponent as ArrowIcon } from "../../../../../../../assets/svg/chevron.svg";
import html2canvas from "html2canvas";
import { downloadCanvasWithTitle, downloadCSVData } from "../../../../../Dashboard/Charts/utils";
import ChartOptionsSidebar from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/ChartOptionsSidebar";
import CustomCheckBox from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/CustomCheckBox";
import FBIntervalSelector from "../../../../../FbInsights/FBIntervalSelector";
import DeleteWidget from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/DeleteWidget";
import moment from "moment-timezone";
import InstagramPageSelector from "../InstagramPageSelector";
import { ChartFilterIcon } from "../../../../../Dashboard/Charts/ChartFilterOptions";
import { ReactComponent as MiniMize } from "../../../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import DownloadChart from "../../../../../Dashboard/Charts/DownloadChart";

function StoryEngagementOverTime(props) {
    const [isNoData, setIsNoDataState] = useState(false);
    const [showAverage, setShowAverage] = useState(true);
    const chart = React.useRef(null);

    const renderDownloadButton = (nodata) => {
        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: downLoadCSV },
                    { name: "PNG", downloadFn: downLoadPNG, showLoader: true },
                ]}
            />
        );
    };

    const downLoadCSV = () => {
        let chartName = props.widget?.name || "Stories Engagement";
        let chartData = props.data || [];
        let downLoadingData = [];
        let formatString = "YYYY-MM-DD HH:mm";
        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let currentChartData = [];
        if (props.activeTab === 0) {
            downLoadingData.push(["Date", "Views Count", "Exits Count"]);
            // chartName = chartName + " View and Exits";
            let viewsChartData = chartData["insta_story"].views_agg;
            let exitsChartData = chartData["insta_story"].exits_agg;
            let count = 0;
            let viewcount = 0;

            viewsChartData.forEach((ele, ind) => {
                count += exitsChartData[ind][1];
                viewcount += ele[1];
                downLoadingData.push([moment(ele[0]).tz(tz).format(formatString), ele[1], exitsChartData[ind][1] || 0]);
            });

            downLoadingData.push(["Total", viewcount, count]);
            downLoadingData.push(["Average", chartData?.insta_story?.avg_views_value, chartData?.insta_story?.avg_exits_value]);
            downloadCSVData(downLoadingData, chartName);
            return;
        }
        if (props.activeTab === 1) {
            downLoadingData.push(["Date", "Replies Count"]);
            // chartName = chartName + " by Replies";
            currentChartData = chartData["insta_story_replies"].comments_agg;
            let count = 0;

            currentChartData.forEach((ele, ind) => {
                count += ele[1];
                downLoadingData.push([moment(ele[0]).tz(tz).format(formatString), ele[1]]);
            });

            downLoadingData.push(["Total", count]);
            downLoadingData.push(["Average", chartData?.insta_story_replies?.avg_value]);
            downloadCSVData(downLoadingData, chartName);
            return;
        }
        if (props.activeTab === 2) {
            downLoadingData.push(["Date", "Forward Taps", "Backward Taps"]);
            // chartName = chartName + " by View and Exits";
            let forwardChartData = chartData["insta_story_by_taps"].forward_agg;
            let backwardChartData = chartData["insta_story_by_taps"].backward_agg;
            let countforward = 0;
            let countbackward = 0;
            forwardChartData.forEach((ele, ind) => {
                countforward += ele[1];
                countbackward += +backwardChartData[ind][1];
                downLoadingData.push([moment(ele[0]).tz(tz).format(formatString), ele[1], backwardChartData[ind][1]]);
            });

            downLoadingData.push(["Total", countforward, countbackward]);
            downloadCSVData(downLoadingData, chartName);
            return;
        }
        if (props.activeTab === 3) {
            downLoadingData.push(["Date", "Reach Count"]);
            // chartName = chartName + " by Reach";
            currentChartData = chartData["insta_story_by_reach"].views_agg;
            let count = 0;

            currentChartData.forEach((ele, ind) => {
                count += ele[1];
                downLoadingData.push([moment(ele[0]).tz(tz).format(formatString), ele[1]]);
            });

            downLoadingData.push(["Total", count]);
            downLoadingData.push(["Average", chartData["insta_story_by_reach"]?.avg_value]);
            downloadCSVData(downLoadingData, chartName);
            return;
        }
        // let count = 0;
        // currentChartData.forEach((ele) => {
        //     count += ele.y;
        //     downLoadingData.push([moment(ele.x).format(formatString), ele.y]);
        // });
        // downLoadingData.push(["Total", count]);
        // downloadCSVData(downLoadingData, chartName);
    };
    const downLoadPNG = (cb) => {
        let chartName = props.widget?.name || "Stories Engagement";

        if (chart?.current)
            return html2canvas(chart.current, { backgroundColor: "#fff", allowTaint: true, useCORS: true, scrollX: 0, scrollY: -window.scrollY }).then(
                (canvas) => {
                    cb && cb();
                    downloadCanvasWithTitle(canvas, chartName);
                },
            );
    };
    const customChangeShowMoreOptions = (e) => {
        let parent = props.containerRef.current.getBoundingClientRect();
        if (e && !props.showMoreOptions) {
            props.changeShowMoreOptions(true);
            props.changeShowMoreOptionsLoc({ x: e.clientX - parent.left - 160, y: e.clientY - parent.top });
        } else {
            props.changeShowMoreOptions(false);
            props.changeShowMoreOptionsLoc(null);
        }
    };
    const increment = () => {
        const selectedPage = props.selectedInstagramPage;
        const pageList = props.instagramPageList;
        const pageIndex = pageList.findIndex((ele) => ele.page_id === selectedPage.value);
        if (pageIndex < pageList.length - 1) {
            let item = pageList[pageIndex + 1];
            let obj = {};
            obj["label"] = `${item.page_name} (${item.status})`;
            obj["id"] = item.id;
            obj["value"] = item.page_id;
            obj["access_token"] = item.access_token;
            props.setSelectedInstagramPage(obj);
        } else {
            let item = pageList[0];
            let obj = {};
            obj["label"] = `${item.page_name} (${item.status})`;
            obj["id"] = item.id;
            obj["value"] = item.page_id;
            obj["access_token"] = item.access_token;
            props.setSelectedInstagramPage(obj);
        }
    };
    const decrement = () => {
        const selectedPage = props.selectedInstagramPage;
        const pageList = props.instagramPageList;
        const pageIndex = pageList.findIndex((ele) => ele.page_id === selectedPage.value);
        if (pageIndex === 0) {
            let item = pageList[pageList.length - 1];
            let obj = {};
            obj["label"] = `${item.page_name} (${item.status})`;
            obj["id"] = item.id;
            obj["value"] = item.page_id;
            obj["access_token"] = item.access_token;
            props.setSelectedInstagramPage(obj);
        } else {
            let item = pageList[pageIndex - 1];
            let obj = {};
            obj["label"] = `${item.page_name} (${item.status})`;
            obj["id"] = item.id;
            obj["value"] = item.page_id;
            obj["access_token"] = item.access_token;
            props.setSelectedInstagramPage(obj);
        }
    };
    const elements = (
        <>
            <div className="widget__header dashboard-widget-container-header skiptranslate">
                <ChartName
                    IsInstagram
                    name={props.widget?.name || "Stories Engagement"}
                    isIGPage={props.isIGPage}
                    info="This graph shows the number of times people have engaged with your post through replies, and tracks views, taps, exits and reach of the post. The average line shows the average per story for stories that were published for the date range selected."
                />
                <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                    {!isNoData && (
                        <div className="chart-type">
                            <span onClick={() => props.changeGraphType("bar")} className={props.graph_type === "bar" ? "active-chart" : ""}>
                                <Icon name="bar chart" />
                            </span>
                            <span onClick={() => props.changeGraphType("line")} className={props.graph_type === "line" ? "active-chart" : ""}>
                                <Icon name="line chart" />
                            </span>
                        </div>
                    )}
                    {!props.isIGPage &&
                        !props.isPublic &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && (
                            <ChartFilterIcon
                                chartFilterApplied={props.chartFilterApplied}
                                changeShowChartFilterOptions={props.changeChartFilter}
                                widgetListDashboardCurrent={props.widgetListDashboardCurrent}
                                name={props.widget.name}
                            />
                        )}

                    {!props.isPublic && !props.isResearchDashboard && !isNoData && renderDownloadButton(isNoData)}
                    {
                        <>
                            {props.isIGPage || (props.isPublic && isNoData) ? null : (
                                <Popup
                                    className="skiptranslate"
                                    trigger={
                                        props.expand ? (
                                            <MiniMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                        ) : (
                                            <MaxiMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                        )
                                    }
                                    inverted
                                    content={props.expand ? "Minimize Widget" : "Maximize Widget"}
                                    size="mini"
                                    position="bottom center"
                                    style={{ zIndex: "99999" }}
                                />
                            )}
                        </>
                    }
                    {props.isPublic && isNoData ? null : (
                        <MoreOptions
                            className={isNoData && props.isIGPage ? "pointer-disabled" : "more-options"}
                            onClick={props.isIGPage ? (e) => customChangeShowMoreOptions(e) : (e) => props.changeShowMoreOptions(e)}
                        />
                    )}
                </div>
                {props.showMoreOptions && (
                    <ChartOptionsSidebar
                        data-html2canvas-ignore="true"
                        showMoreOptionsLoc={props.showMoreOptionsLoc}
                        changeShowMoreOptions={props.isIGPage ? (e) => customChangeShowMoreOptions(e) : (e) => props.changeShowMoreOptions(e)}>
                        {!isNoData && (
                            <>
                                {/* <CustomCheckBox
                                    label="Show Unique"
                                    checked={props.showUniqueLines}
                                    onClick={() => props.changeShowUniqueLine(!props.showUniqueLines)}
                                /> */}
                                <CustomCheckBox label="Show Legends" checked={props.showLegend} onClick={() => props.changeShowLegend(!props.showLegend)} />
                                <CustomCheckBox
                                    label="Show Grid Lines"
                                    checked={props.showGridLines}
                                    onClick={() => props.changeShowGridLines(!props.showGridLines)}
                                />
                                {props.activeTab !== 2 && (
                                    <CustomCheckBox label="Show Average" checked={showAverage} onClick={() => setShowAverage((val) => !val)} />
                                )}
                                {/* <CustomCheckBox label="Show Label" checked={props.showLabel} onClick={() => props.changeShowLabel(!props.showLabel)} /> */}
                                <FBIntervalSelector
                                    aggs_val={props.aggs_val}
                                    appliedFilter={props.appliedFilter}
                                    handleIntervalChange={props.handleIntervalChange}
                                />
                            </>
                        )}
                        {!props.isIGPage &&
                            !props.isPublic &&
                            !props.isStandardDashboard &&
                            !props.isResearchDashboard &&
                            props.dashboardPageType !== "temporaryInsights" &&
                            props.dashboardPageType !== "temporary" && (
                                <>
                                    <div className="chart-settings menu-option" onClick={props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                    <div className="clone-chart menu-option" onClick={props.cloneWidget}>
                                        <span>Clone Chart</span>
                                        <CloneIcon />
                                    </div>
                                    <DeleteWidget onClick={props.deleteWidget} />
                                </>
                            )}
                    </ChartOptionsSidebar>
                )}
            </div>
            <div className="dashboard-chart dashboard-chart-slider skiptranslate" ref={chart}>
                {!props.isIGPage && (
                    <div
                        data-html2canvas-ignore="true"
                        className={`chart-slider chart-slider-left ${props.instagramPageList.length === 1 ? "disabled" : ""}`}
                        onClick={() => decrement()}>
                        <ArrowIcon />
                    </div>
                )}
                <div className="chart-area">
                    {!props.isIGPage && (
                        <InstagramPageSelector
                            selectedPage={props.selectedInstagramPage}
                            setSelectedPage={props.setSelectedInstagramPage}
                            pageList={props.instagramPageList}
                            widgetContainerRef={props.widgetContainerRef}
                        />
                    )}
                    <div className="widget__tabs">
                        <div className={`unique_tab ${props.activeTab === 0 ? "active__tab" : ""}`} onClick={() => props.setActiveTab(0)}>
                            Views & Exits
                        </div>
                        <div className={`unique_tab ${props.activeTab === 1 ? "active__tab" : ""}`} onClick={() => props.setActiveTab(1)}>
                            Replies
                        </div>
                        <div className={`unique_tab ${props.activeTab === 2 ? "active__tab" : ""}`} onClick={() => props.setActiveTab(2)}>
                            Taps
                        </div>
                        <div className={`unique_tab ${props.activeTab === 3 ? "active__tab" : ""}`} onClick={() => props.setActiveTab(3)}>
                            Reach
                        </div>
                    </div>
                    {props.activeTab === 0 && (
                        <StoryViewsExits
                            setIsNoDataState={setIsNoDataState}
                            showLegend={props.showLegend}
                            showGridLines={props.showGridLines}
                            showLabel={props.showLabel}
                            graphType={props.graph_type}
                            chartData={props.data}
                            chartDataLoading={props.chartDataLoading}
                            isIGPage={props.isIGPage}
                            widgetContainerRef={props.isIGPage ? chart : props.widgetContainerRef}
                            pageStatus={props.pageStatus}
                            showAverage={showAverage}
                        />
                    )}
                    {props.activeTab === 1 && (
                        <StoryReplies
                            setIsNoDataState={setIsNoDataState}
                            showLegend={props.showLegend}
                            showGridLines={props.showGridLines}
                            showLabel={props.showLabel}
                            graphType={props.graph_type}
                            chartData={props.data}
                            chartDataLoading={props.chartDataLoading}
                            isIGPage={props.isIGPage}
                            widgetContainerRef={props.isIGPage ? chart : props.widgetContainerRef}
                            pageStatus={props.pageStatus}
                            showAverage={showAverage}
                        />
                    )}
                    {props.activeTab === 2 && (
                        <StoriesTaps
                            setIsNoDataState={setIsNoDataState}
                            showLegend={props.showLegend}
                            showGridLines={props.showGridLines}
                            showLabel={props.showLabel}
                            graphType={props.graph_type}
                            chartData={props.data}
                            chartDataLoading={props.chartDataLoading}
                            isIGPage={props.isIGPage}
                            widgetContainerRef={props.isIGPage ? chart : props.widgetContainerRef}
                            pageStatus={props.pageStatus}
                            // showAverage={showAverage}
                        />
                    )}
                    {props.activeTab === 3 && (
                        <StoriesReach
                            setIsNoDataState={setIsNoDataState}
                            showLegend={props.showLegend}
                            showGridLines={props.showGridLines}
                            showLabel={props.showLabel}
                            graphType={props.graph_type}
                            chartData={props.data}
                            chartDataLoading={props.chartDataLoading}
                            isIGPage={props.isIGPage}
                            widgetContainerRef={props.isIGPage ? chart : props.widgetContainerRef}
                            showAverage={showAverage}
                            pageStatus={props.pageStatus}
                        />
                    )}
                </div>
                {!props.isIGPage && (
                    <div
                        data-html2canvas-ignore="true"
                        className={`chart-slider chart-slider-right ${props.instagramPageList.length === 1 ? "disabled" : ""}`}
                        onClick={() => increment()}>
                        <ArrowIcon />
                    </div>
                )}
            </div>
        </>
    );
    return props.isIGPage ? <div className="dashboard-widget-container">{elements}</div> : <>{elements}</>;
}

export default StoryEngagementOverTime;
